export default __webpack_public_path__ + "static/media/jinseon.99d74896.jpg";